import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/icons/pdf.svg'


const _hoisted_1 = { class: "d-flex gap-20 w-100 flex-md-row flex-column" }
const _hoisted_2 = { class: "bordered-card w-30 w-sm-100 sm-mb-10" }
const _hoisted_3 = { class: "d-flex flex-column gap-20" }
const _hoisted_4 = { class: "fs-xs" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "text-primary" }
const _hoisted_7 = { class: "bordered-card transparent gap-15 align-items-center justify-content-between flex-md-row flex-column" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-list-view-rectangle" }, null, -1)
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "pdf icon"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createTextVNode("Current "),
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.coverageLabel) + " Balance", 1)
        ]),
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.formatCurrency(_ctx.balance)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("h2", {
        class: _normalizeClass({'fs-base-lg fw-normal sm-fs-sm w-sm-100': _ctx.small, 'fs-base-lg fw-normal w-30 sm-fs-sm w-sm-100': !_ctx.small})
      }, "What is covered/ Reimbursable?", 2),
      _createElementVNode("a", {
        href: _ctx.links.list,
        target: "_blank",
        class: "btn btn-secondary plan-modal w-sm-100"
      }, [
        _hoisted_9,
        _createTextVNode(" See List ")
      ], 8, _hoisted_8),
      _createElementVNode("a", {
        href: _ctx.links.form,
        target: "_blank",
        class: "btn btn-primary w-sm-100"
      }, [
        _createTextVNode(" Download Claim Form "),
        _hoisted_11
      ], 8, _hoisted_10)
    ])
  ]))
}